<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: leftcolumn }">
        <a-form-item label="Used For">
          <a-radio-group
            v-decorator="[
              'used_for',
              { rules: [{ required: true }], initialValue:'0' },
            ]"
            @change="handleUseFor"
          >
            <a-radio value="0">Item</a-radio>
            <a-radio value="2">Tax</a-radio>
            <a-radio value="3">Shipping</a-radio>
            <a-radio value="4">Etc</a-radio>
            <a-radio value="1">Discount</a-radio>
          </a-radio-group>
        </a-form-item>
        <div v-if="trigered.tax">
          <a-form-item label="Tax Type">
            <a-select
              v-decorator="[
                'type_tax',
                {
                  rules: [{ required: true }],
                },
              ]"
              
              showSearch
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                  v-for="item in listType_tax"
                  :key="item.value"
                  :value="item.value"
                >
                {{item.text}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <a-form-item
          label="PP Detil" 
          v-if="trigered.powodtl"
        >
          <a-select
            showSearch
            allowClear
            v-decorator="[
              'powopdtl',
              { rules: [{ required: true }] },
            ]"
            
          >
            <a-select-option v-for="item in po_wo_dtl" :key="item.id_pp_dtl" :disabled="item.saldo<=0">
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  [{{ item.kode_anggaran }}] {{ item.nama_barang }}
                </div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.saldo))
                      }}
                    </b>
                </div>
              </div>
            </a-select-option>
          </a-select>
          <!-- <div v-if="dtl_desc.unit_price!=''" class="m-form-description-small">
            <div class="m-display-flex space-between align-middle" slot="header">
              <span><b>Quantity : </b>{{dtl_desc.qty}}</span>
             <span><b>Unit Price : </b>{{formatCurrency(dtl_desc.currency,dtl_desc.unit_price)}}</span>
            </div>
          </div> -->
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            v-decorator="['nama_item', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="24" v-if="trigered.value.byQty">
          <a-col :span="getScreen ? 24 : 6">
            <a-form-item label="Quantity">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'quantity',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
                ref="rawqty"
                @change="convertingValueQty"
              />
            </a-form-item>
          </a-col>
          <a-col :span="getScreen ? 24 : 18">
            <a-form-item label="Value (IDR)">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
                ref="rawval"
                @change="convertingValue"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
              />
            </a-form-item>
            <span v-if="net_value && informasi.mata_uang!='IDR'">Value ({{informasi.mata_uang}}) : {{ formatCurrency(informasi.mata_uang,net_value) }}</span>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="trigered.value.byOption">
          <a-col :span="24">
            <a-form-item label="Value (IDR)">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }] },
                ]"
                ref="rawval"
                @change="convertingValue"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
              />
            </a-form-item>
            <span v-if="net_value && informasi.mata_uang!='IDR'">Value ({{informasi.mata_uang}}) : {{ formatCurrency(informasi.mata_uang,net_value) }}</span>
          </a-col>
        </a-row>
        <a-form-item label="Note">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'note',
              { rules: [{ required: false }] },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleNewItem"
            block
            type="primary"
            html-type="submit"
            :loading="newLoading"
            ref="addMainBtn"
            v-decorator="['addMainBtn']"
            >Add</a-button
          >
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: rightcolumn }">
        <a-card class="m-height-full m-display-flex nowrap flex-column">
          <div slot="title">
              <span>Purchase List</span>
          </div>
          <template slot="extra">
              <a-button @click="handleExpand()" v-if="!getScreen">
              <span>{{ labelExpand }}</span>
              </a-button>
          </template>
          <div class="body-flex">
            <a-table
              :columns="columns"
              :dataSource="getCountWeb"
              :pagination="pagination"
              size="small"
              :scroll="{ x: 700 }"
              bordered
            >
            <template slot="nama_item" slot-scope="index, item">
              <b>[{{lblusedfor(item.used_for)}}]
                <span v-if="item.used_for=='2'">[{{lblTax(item.type_tax)}}]</span>
              </b> <br/>{{item.nama_item}}<br/>
              <i><small>{{item.note}}</small></i>
            </template>
            <template slot="itemPoWoDtl" slot-scope="index, item">
              <b>{{item.pp_nama_barang}}</b><br/>
              <span><small>{{item.pp_kode_anggaran}}</small></span>
            </template>
            <template slot="unit_price" slot-scope="index, item">
              <div><b>{{formatCurrency('IDR',item.value_label)}}</b></div>
              <small v-if="informasi.mata_uang!='IDR'">{{formatCurrency(informasi.mata_uang,item.value)}}</small>
            </template>
            <template slot="amount" slot-scope="index, item">
              <div><b>{{formatCurrency('IDR',item.value_label*(item.quantity ? item.quantity : 1))}}</b></div>
              <small v-if="informasi.mata_uang!='IDR'">{{formatCurrency(informasi.mata_uang,item.value*(item.quantity ? item.quantity : 1))}}</small>
            </template>
            <template slot="operation" slot-scope="index, item">
              <div class="m-width-full">
              <a-button-group class="m-width-full">
                <a-button
                class="m-width-full"
                  size="small"
                  type="primary"
                  @click="handleToEdit(item)"
                  :disabled="totalDiscList>0 && item.used_for!='1'"
                >
                  <a-icon type="edit" />
                </a-button>
                <a-button type="danger"
                class="m-width-full"
                  size="small"
                  @click="handleToDelete(item)"
                  :disabled="totalDiscList>0 && item.used_for!='1'"
                  >
                  <a-icon type="close"/>
                </a-button>
              </a-button-group>
              </div>
            </template>
            </a-table>
            <div class="m-price-total">
              <a-row type="flex">
                <a-col :span="informasi.mata_uang=='IDR'? 10 : 4" :order="1" class="m-text-align left">Sub Total</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="informasi.mata_uang=='IDR'? 13 : 10"
                  :order="3"
                  class="m-text-align left"
                >
                  <b>
                    <CurrencyJustified
                      :currencyValue="'IDR'"
                      :valueNumber="totalPrice*informasi.kurs"
                    />
                  </b>
                </a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="1"
                  :order="4"
                  class="m-text-align right"
                >|&nbsp;</a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="8"
                  :order="5"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                      :currencyValue="informasi.mata_uang"
                      :valueNumber="totalPrice"
                    />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="informasi.mata_uang=='IDR'? 10 : 4" :order="1" class="m-text-align left">Discount</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="informasi.mata_uang=='IDR'? 13 : 10"
                  :order="3"
                  class="m-text-align left"
                >
                <b>
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="totalDiscList*informasi.kurs"
                  />
                </b>
                </a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="1"
                  :order="4"
                  class="m-text-align right"
                >|&nbsp;</a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="8"
                  :order="5"
                  class="m-text-align left"
                >
                <CurrencyJustified
                    :currencyValue="informasi.mata_uang"
                    :valueNumber="totalDiscList"
                  />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="informasi.mata_uang=='IDR'? 10 : 4" :order="1" class="m-text-align left">DPP</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="informasi.mata_uang=='IDR'? 13 : 10"
                  :order="3"
                  class="m-text-align left"
                >
                <b>
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="(totalPrice-totalDiscList)*informasi.kurs"
                  />
                </b>
                </a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="1"
                  :order="4"
                  class="m-text-align right"
                >|&nbsp;</a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="8"
                  :order="5"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="informasi.mata_uang"
                    :valueNumber="totalPrice-totalDiscList"
                  />
                </a-col>
              </a-row>
              <a-row type="flex">
                <a-col :span="informasi.mata_uang=='IDR'? 10 : 4" :order="1" class="m-text-align left">Tax</a-col>
                <a-col
                  :span="1"
                  :order="2"
                  class="m-text-align left"
                >
                </a-col>
                <a-col
                  :span="informasi.mata_uang=='IDR'? 13 : 10"
                  :order="3"
                  class="m-text-align left"
                >
                <b>
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="nilaiPajak*informasi.kurs"
                  />
                </b>
                </a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="1"
                  :order="4"
                  class="m-text-align right"
                >|&nbsp;</a-col>
                <a-col
                  v-if="informasi.mata_uang!='IDR'"
                  :span="8"
                  :order="5"
                  class="m-text-align left"
                >
                  <CurrencyJustified
                    :currencyValue="informasi.mata_uang"
                    :valueNumber="nilaiPajak"
                  />
                </a-col>
              </a-row>
              <a-divider class="margin-medium" />
              <a-statistic
                title="Total"
                :value="formatCurrency('IDR', grandTotal.all*informasi.kurs)"
                class="margin-top m-text-align right"
              />
              <div class="m-text-align right" v-if="informasi.mata_uang!='IDR'">
                <small>
                  | {{ formatCurrency(informasi.mata_uang, grandTotal.all) }}
                </small>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      v-model="editModal"
      v-if="editModal"
      @ok="handleEditModal"
      @cancel="handleClose"
      :maskClosable="false"
      :footer="null"
    >
      <span slot="title">
        <a-icon type="form" class="margin-right-small" />Change
      </span>

      <a-form :form="modalForm">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-form-item label="Used For">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'used_for',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.used_for,
                  },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="0">Item</a-radio>
                <a-radio value="2">Tax</a-radio>
                <a-radio value="3">Shipping</a-radio>
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <div v-if="trigered.tax">
          <a-form-item label="Tax Type">
            <a-select
              v-decorator="[
                'type_tax',
                {
                  rules: [{ required: true }],
                  initialValue: editData.type_tax
                },
              ]"
              @change="taxTypeChange"
              showSearch
              option-filter-prop="children"
              :filter-option="filterOption"
              disabled
            >
              <a-select-option
                  v-for="item in listType_tax"
                  :key="item.value"
                  :value="item.value"
                >
                {{item.text}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <a-form-item
          label="PP Detil" v-if="trigered.powodtl"
        >
          <a-select
            showSearch
            allowClear
            v-decorator="[
              'powopdtl',
              { rules: [{ required: true }], initialValue: editData.po_wo_id },
            ]"
            
            :disabled="true"
          >
            <a-select-option v-for="item in po_wo_dtl" :key="item.id_pp_dtl" :disabled="item.saldo<=0">
              <div class="elipsdiv">
                <div class="elipsdiv-mouseover-label1" >
                  [{{ item.kode_anggaran }}] {{ item.nama_barang }}
                </div>
                <div class="elipsdiv-mouseover-label2">
                    <b style="float: right">{{
                        formatCurrency(item.currency,parseFloat(item.saldo))
                      }}
                    </b>
                </div>
              </div>
            </a-select-option>
          </a-select>
          <!-- <div v-if="dtl_desc.unit_price!=''" class="m-form-description-small">
            <div class="m-display-flex space-between align-middle" slot="header">
              <span><b>Quantity : </b>{{dtl_desc.qty}}</span>
             <span><b>Unit Price : </b>{{formatCurrency(dtl_desc.currency,dtl_desc.unit_price)}}</span>
            </div>
          </div> -->
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            v-decorator="[
              'nama_item',
              {
                rules: [{ required: true }],
                initialValue: editData.nama_item,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="24" v-if="trigered.value.byQty">
          <a-col :span="getScreen ? 24 : 6">
            <a-form-item label="Quantity">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'quantity',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: editData.quantity },
                ]"
                ref="rawqty2"
                @change="convertingValueQty2"
              />
            </a-form-item>
          </a-col>
          <a-col :span="getScreen ? 24 : 18">
            <a-form-item label="Value (IDR)">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: editData.value_label },
                ]"
                ref="rawval2"
                @change="convertingValue2"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }], initialValue: editData.value },
                ]"
                ref="rawval2"
                @change="convertingValue2"
              />
            </a-form-item>
            <span v-if="net_value && informasi.mata_uang!='IDR'">Value ({{informasi.mata_uang}}) : {{ formatCurrency(informasi.mata_uang,net_value) }}</span>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="trigered.value.byOption">
          <a-col :span="24">
            <a-form-item label="Value">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkMaxValue }], initialValue: editData.value_label },
                ]"
                ref="rawval2"
                @change="convertingValue2"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'value',
                  { rules: [{ required: true }, { validator: checkPrice }], initialValue: editData.value },
                ]"
              />
            </a-form-item>
            <span v-if="net_value && informasi.mata_uang!='IDR'">Value ({{informasi.mata_uang}}) : {{ formatCurrency(informasi.mata_uang,net_value) }}</span>
          </a-col>
        </a-row>
        <a-form-item label="Note">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'note',
              { rules: [{ required: false }], initialValue: editData.note },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
            v-decorator="['change']"
            ref="change"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
import nanoid from "nanoid";

export default {
  name: "Detail",
  mixins: [CurrencyFormat,GlobalMethod],
  props: {
    listData: {},
    informasi: {},
    mode: String,
    tax: String,
    id_pp: String,
    po_wo_dtl:{},
  },
  data() {
    return {
      net_value: null,
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      editModal: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      push: [],
      newLoading: false,
      dataPN: [],
      selectedPN: null,
      selectedPNm: null,
      selectedPPdtl: null,
      trigered: {
        tax: false,
        used_for: "0",
        percentage: false,
        Modalpercentage: false,
        disabledTaxBearer: false,
        ppdtl:false,
        powodtl:true,
        value:{
          byQty: true,
          byOption: false,
        },
        attachment: false,
      },
      formUsed:false,
      dtl_desc: {
        qty: "",
        unit_price:"",
        currency:"",
      },
      fileList:[],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getType_tax"]),
    totalPrice() {
      let total = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "0" === item.used_for ||  "3" === item.used_for || "4" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            total += Number(item.value)*(item.quantity ? item.quantity : 1);
          });

        //menghitung jika tidak ada entri item namun entri pajak atau pph dll
        // let existitem = this.listData.filter((item) => "0" === item.used_for);
        // let existotheritem = this.listData.filter((item) => "0" != item.used_for);
        // if (existitem.length == 0 && existotheritem.length > 0) {
        //   if (existotheritem.length > 0)
        //     existotheritem.forEach((item) => {
        //       total += Number(item.value) * Number(item.quantity ? item.quantity : 1);
        //     });
        // }
      }

      return total;
    },
    totalDiscList() {
      let total = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "1" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            if (item.cur_type == "percentage") {
              total = total + (this.totalPrice * parseFloat(item.value)) / 100;
            } else {
              total = total + parseFloat(item.value);
            }
          });
      }

      return total;
    },
    grandTotal() {
      return {
        all: this.totalPrice + this.nilaiPajak - this.totalDiscList,
        item: this.totalPrice
      };
    },
    nilaiPajak() {
      let tax = 0;
      if (this.listData.length > 0) {
        let vdata = this.listData.filter((item) => "2" === item.used_for);
        let isitemlist = this.listData.filter((item) => "0" === item.used_for);
        //console.log("vdata",vdata)
        if (vdata.length > 0)
          vdata.forEach((item) => {
            if (isitemlist.length > 0 && (item.type_tax && item.type_tax.includes("pph") && !item.type_tax.includes("impor"))) {
              tax = tax + 0;
            } else {
              tax = tax + parseFloat(item.value);
            }
          });
      }
      return tax;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          dataIndex: "nama_item",
          width: 250,
          scopedSlots: { customRender: "nama_item" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detail",
          width: 250,
          scopedSlots: { customRender: "itemPoWoDtl" },
          sorter: (a, b) => a.powo_nm.length - b.powo_nm.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          align: "center",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Values",
          align: "right",
          key: "hargaTotal",
          width: 150,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Total Value",
          key: "amount",
          align: "right",
          width: 150,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 70,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      //let data = _.filter(this.listData,(item) => item.values.is_item == "yes");
      let data = [...this.listData];
      if (data) {
        data.forEach((value, index) => {
          data[index]["no"] = index + 1;
          if(value.type_tax && value.type_tax.includes("pph")){
            data[index]["key"] = "pphgrid" + (index + 1);
          }else{
            data[index]["key"] = "agrid" + (index + 1);
          }

          data[index]["nama_item"] = value.nama_item;

          let temp = _.filter(this.po_wo_dtl, (item)=> item.id_pp_dtl==value.po_wo_id)
          data[index]["pp_nama_barang"] = temp.length>0 ? temp[0].nama_barang :null;
          data[index]["pp_kode_anggaran"] = temp.length>0 ? temp[0].kode_anggaran : null;

          data[index]["quantity"] = value.quantity;
          data[index]["value"] = value.value;
        });
      }
      return data;
    },
    listType_tax(){
      return _.filter(this.getType_tax,(item) => !item.value.includes('pph') || item.value.includes('pph_22_impor'));
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("handleReplace", this.handleReplace);

    let result = this.initialCounting(this.po_wo_dtl,this.listData);
    Event.$emit("updatepowodtl", { value: result.ppdtl});
  },
  activated(){
    let result = this.initialCounting(this.po_wo_dtl,this.listData);
    Event.$emit("updatepowodtl", { value: result.ppdtl});
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("handleReplace", this.handleReplace);
  },
  methods: {
    moment,
    handleUseFor(val) {
      //console.log(val)
      this.form.resetFields();
      let vals = val.target.value;
      this.trigered.used_for = vals;
      this.dtl_desc = {
        qty: "",
        unit_price: "",
        currency: ""
      };
      if (vals=='2'){
        this.trigered.tax = true;
        //this.trigered.attachment = true;
      }else{
        this.trigered.tax = false;
        //this.trigered.attachment = false;
      }

      if(vals=='0'){
        this.trigered.value.byQty=true;
        this.trigered.value.byOption=false;
      }else{
        this.trigered.value.byQty=false;
        this.trigered.value.byOption=true;
      }

      if(vals=='1'){
       this.trigered.powodtl = false;
      }else{
       this.trigered.powodtl = true;
        // this.$nextTick(function () {
        //   this.form.setFieldsValue({
        //     po_wo_id: null,
        //   });
        // });
      }
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    preventEnterButtonModal() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.change.$children[0].$el.focus();
      });
    },
    handleOption(val) {
      if (val == "percentage") {
        this.trigered.percentage = true;
      } else {
        this.trigered.percentage = false;
      }
    },
    handleOptionModal(val) {
      if (val == "percentage") {
        this.trigered.Modalpercentage = true;
      } else {
        this.trigered.Modalpercentage = false;
      }
    },
    handleRef() {
      if (this.listData.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        // Event.$emit("poData", { estimated_value: this.totalPrice });

        //regenerate ulang harga total untuk memutakhirkan percentage harga terakhir
        for (let index = 0; index < this.listData.length; index++) {
          if (this.listData[index].used_for == "0") {
            this.listData[index].valueTotal = this.listData[index].value;
          } else {
            if (this.listData[index].cur_type == "percentage") {
              if (this.listData[index].used_for == "1") {
                this.listData[index].valueTotal =
                  (this.totalPrice * parseFloat(this.listData[index].value)) /
                  100;
              } else {
                this.listData[index].valueTotal =
                  ((this.totalPrice - this.totalDiscList) *
                    parseFloat(this.listData[index].value)) /
                  100;
              }
            } else {
              this.listData[index].valueTotal = this.listData[index].value;
            }
          }
        }

        if (this.grandTotal < 0) {
          this.displayMessageValue(
            "error-other",
            "Subtotal must be greater then -1!"
          );
        } else {
          Event.$emit("invData", {
            listData: this.listData,
            emptyValidator: this.listData.length,
            total: this.grandTotal.all,
          });
        }
      }
    },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.newLoading = false;
          this.displayMessage("form-warning");
          return;
        }

        if (values.used_for == "1") {
          if(this.net_value>(this.totalPrice-this.totalDiscList)){
            this.displayMessageValue(
            "error-other",
            "Discount must be lather then Subtotal value!"
          );
            return
          }
        }

        if (values.used_for == "0" && values.cur_type == "percentage") {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Subtotal cannot be filled with a percentage value!"
          );
          return;
        }
        if (values.used_for == "0" && this.net_value == 0) {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Subtotal cannot be 0 value!"
          );
          return;
        }

        if (values.quantity<=0) {
          this.newLoading = false;
          this.displayMessageValue(
            "error-other",
            "Quantity must be grather then 0!"
          );
          return;
        }

        if (this.net_value<=0) {
          this.displayMessageValue(
            "error-other",
            "Value must be grather then 0!"
          );
          return;
        }

        if(values.powopdtl){
          let exis = _.filter(this.listData,(item)=> item.id_pp_dtl == values.powopdtl);
          if(exis.length>0){
            this.newLoading = false;
            this.displayMessageValue(
              "error-other",
              "PP Detil have been Used, data can only be edited!"
            );
            return;
          }
        }

        this.newLoading = true;
        let val = {...values};
        val.key = nanoid();

        let powodtl=[];
        if(values.powopdtl){
          powodtl = this.po_wo_dtl.filter((valu) => valu.id_pp_dtl == values.powopdtl);
          val.powo_nm=powodtl[0].item;
        }
        //console.log("val",val)

        let isprocess = true;
        if (this.listData.length > 0) {
          let newdata = this.listData.filter((valu) => valu.used_for == "0" && valu.nama_item.toLowerCase()==values.nama_item.toLowerCase());
          if (newdata.length == 1 && val.used_for == "0") {
            this.confirmMessageValue("confirm-replace", val);
            isprocess = false;
            //this.newLoading = false;
            //return
          }
        } else {
          if (values.used_for !== "0" && !this.informasi.pib) {
            isprocess = false;
            this.displayMessageValue(
              "error-other",
              "Subtotal must be filled in first!"
            );
            this.newLoading = false;
            return;
          }
        }

        if (isprocess) {
          let tp = [];
          for (let i = 0; i < this.listData.length; i++) {
            tp.push({...this.listData[i]});
          }
          
          let dt = {
            used_for: val.used_for,
            po_wo_id: val.powopdtl,
            nama_item: val.nama_item,
            quantity : val.quantity,
            powo_nm: val.powo_nm,
            value: this.net_value/(val.quantity ? val.quantity : 1),
            value_label: val.value,
            type_tax: val.type_tax,
            note: val.note,
          };
          tp.push(dt);
          let dd = [];
          this.po_wo_dtl.forEach((item) => {
            dd.push(item);
          });
          let result = this.initialCounting(dd,tp);
          if(result.valid){
            Event.$emit("updatepowodtl", { value: result.ppdtl});
            Event.$emit("updateList", { value: tp, type: "delete" });
            this.resetForm();
            this.newLoading = false;
           }else if(result.grandtotalminus){
            this.displayMessageValue(
              "basic-error",
              "Subtotal result can't be minus!"
            );
            this.newLoading = false;
            return;
          }else if(!result.valid){
            this.displayMessageValue(
              "basic-error",
              "The value is grather then Budget PP Detail!"
            );
            this.newLoading = false;
            return;
          }
        }
      });
    },
    handleReplace(val) {
      //console.log("handleReplace",val)
      let newdata = this.listData.filter(
        (valu) => valu.used_for !== val.used_for
      );
      newdata.push(val);
      Event.$emit("updateList", { value: newdata, type: "delete" });
      this.resetForm();
      this.newLoading = false;
    },
    handleRemove(item) {
      //console.log(item)
      this.confirmMessageValue("confirm-delete", item, null);
    },
    delete(val) {
      const newPush = this.listData.filter((item) => item.key !== val.key);

      // let mintrans = _.filter(newPush, (el) => el.used_for=="0" && el.key !== val.key);
      // let othertrans = _.filter(newPush, (el) => el.used_for!="0" && el.key !== val.key);
      // if(othertrans.length>0 && mintrans.length==0){
      //   this.displayMessageValue(
      //     "basic-error",
      //     "There must be at least one transaction of type use for 'Item Subtotal'!"
      //   );
      //   return;
      // }

      let dd = [];
      this.po_wo_dtl.forEach((item) => {
        dd.push(item);
      });
      let result = this.initialCounting(dd,newPush);
      if(result.valid){
        Event.$emit("updateList", { value: newPush, type: "delete" });
        Event.$emit("updatepowodtl", { value: result.ppdtl});
        this.modalForm.resetFields();
        this.resetForm();
      }else if(!result.valid){
        this.displayMessageValue(
          "basic-error",
          "The value is grather then Budget PP Detail!"
        );
        return;
      }else if(result.grandtotalminus){
        this.displayMessageValue(
          "basic-error",
          "The value can't exceed the total value!"
        );
        return;
      }
    },
    handleEditModal(item) {
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.disc = item.used_for == "0" ? true : false;
    },
    handleEditModalSubtotal() {
      this.modalForm.resetFields();
      let val = this.listData.filter((item) => item.used_for == "0");
      this.editData = val[0];
      this.editModal = !this.editModal;
      this.trigered.disc = this.editData.used_for == "0" ? true : false;
    },
    handleClose() {
      this.resetForm();
      if(this.editData.po_wo_id){
        let ppdtl = [];      
        for (let t = 0; t < this.po_wo_dtl.length; t++) {
          ppdtl.push({...this.po_wo_dtl[t]});
        }
        let id_pp_dtl = this.editData.po_wo_id;
        let index = _.findIndex(ppdtl, (e) => {return e.id_pp_dtl == id_pp_dtl;}, 0); 
        ppdtl[index].saldo = this.editData.powovalue_before;
        Event.$emit("updatepowodtl", { value: ppdtl});
        
      }
    },
    resetForm() {
      this.fileList = [];
      this.trigered.used_for = "0";
      this.trigered.percentage = false;
      this.trigered.value.byQty = true;
      this.trigered.value.byOption = false;
      this.trigered.powodtl = true;
      this.trigered.attachment = false;
      this.trigered.tax = false;

      this.dtl_desc.unit_price = "";
      this.dtl_desc.qty = "";
      this.dtl_desc.currency = "";

      this.net_value = null;

      this.form.resetFields();
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (values.used_for == "1") {
          if(this.net_value>(this.totalPrice+this.editData.value-this.totalDiscList)){
            this.displayMessageValue(
            "error-other",
            "Discount must be lather then Subtotal value!"
          );
            return
          }
        }

        if (values.quantity<=0) {
          this.displayMessageValue(
            "error-other",
            "Quantity must be grather then 0!"
          );
          return;
        }

        if (this.net_value<=0) {
          this.displayMessageValue(
            "error-other",
            "Value must be grather then 0!"
          );
          return;
        }

        let findNames = null;
        findNames = _.filter(
          this.listData,
          (obj) =>
            obj.used_for &&
            obj.used_for.toLowerCase() == values.used_for.toLowerCase() &&
            obj.nama_item &&
            obj.nama_item.toLowerCase() == values.nama_item.toLowerCase()
        );

        if (findNames.length > 0 && findNames[0].key !== id_key) {
          this.displayMessage("form-duplicate");
          return;
        } else {

          let tp = [];
          for (let i = 0; i < this.listData.length; i++) {
            tp.push({...this.listData[i]});
          }
          let indx = _.findIndex(tp, {key: id_key});
          tp[indx].value = this.net_value/(values.quantity ? values.quantity : 1);
          tp[indx].value_label = values.value;
          tp[indx].nama_item= values.nama_item,
          tp[indx].quantity= values.quantity,
          //tp[indx].powo_nm= values.powo_nm,
          //tp[indx].type_tax= powodtl.length>0 ? powodtl[0].type_tax : null,
          tp[indx].note= values.note;

          let dd = [];
          this.po_wo_dtl.forEach((item) => {
            dd.push(item);
          });
          let result = this.initialCounting(dd,tp);

          if(result.valid){
            Event.$emit("updatepowodtl", { value: result.ppdtl});
            Event.$emit("updateList", { value: tp, type: "delete" });
            this.editModal = !this.editModal;
            this.resetForm();
            this.displayMessageValue(
              "update-item",
              values.nama_item ? values.nama_item : "Subtotal"
            );
          }else if(!result.valid){
            this.displayMessageValue(
              "basic-error",
              "The value is grather then Budget PP Detail!"
            );
            return;
          }else if(result.grandtotalminus){
            this.displayMessageValue(
              "basic-error",
              "The value cann't exceed the grand total value!"
            );
            return;
          }
        }
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    checkMaxValue(rule, value, callback) {
      if (value <= 9999999999999) {
        callback();
        return;
      }
      callback("Max. value 9.999.999.999.999!");
    },
    changeTaxBearer(val){
        if(val.target.value=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlepowodtl(){

    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
      }
    },
    handleToDelete(val){
    const newPush = this.listData.filter((item) => item.key !== val.key);

    let mintrans = _.filter(newPush, (el) => el.used_for=="0" && el.key !== val.key);
      let othertrans = _.filter(newPush, (el) => el.used_for!="0" && el.key !== val.key);
      if(othertrans.length>0 && mintrans.length==0 && !this.informasi.pib){
        this.displayMessageValue(
          "basic-error",
          "There must be at least one transaction of type use for 'Item Subtotal'!"
        );
        return;
      }

      let dd = [];
      this.po_wo_dtl.forEach((item) => {
        dd.push(item);
      });
      let result = this.initialCounting(dd,newPush);
      if(result.valid){
        Event.$emit("updateList", { value: newPush, type: "delete" });
        Event.$emit("updatepowodtl", { value: result.ppdtl});
        this.modalForm.resetFields();
        this.resetForm(result.ppdtl);
      }else if(!result.valid){
        this.displayMessageValue(
          "basic-error",
          "The value is grather then Budget PP Detail!"
        );
        return;
      }else if(result.grandtotalminus){
        this.displayMessageValue(
          "basic-error",
          "The value cann't exceed the grand total value!"
        );
        return;
      }
    },
    initialCounting(lsdtl,listPurchasing){
      let ppdtl = [];      
      for (let t = 0; t < lsdtl.length; t++) {
        ppdtl.push({...lsdtl[t]});
      }

      //reset nilai ppdtl sesuai nilai origin
      for (let b = 0; b < ppdtl.length; b++) {
        ppdtl[b].saldo = Number(ppdtl[b].saldo_ori);
      }

      let valid = true;
      let grandtotalminus = false;
      for (let i = 0; i < listPurchasing.length; i++) {
        let index = _.findIndex(ppdtl, {id_pp_dtl: listPurchasing[i].po_wo_id});

        if(index>=0){
          let values = Number(listPurchasing[i].value)*Number(listPurchasing[i].quantity ? listPurchasing[i].quantity : 1);
          let hsl = (Number(ppdtl[index].saldo)-values);
// console.log("initialvounting",Number(ppdtl[index].saldo), values)
          ppdtl[index].saldo = hsl;
        }else if(listPurchasing[i].used_for=='1'){
          let totalitem = 0;
          for (let q = 0; q < listPurchasing.length; q++) {
            if(listPurchasing[q].po_wo_id!=undefined){
              totalitem += listPurchasing[q].value*(listPurchasing[q].quantity ? listPurchasing[q].quantity : 1);
            }
          }
          //discount proportional
          for (let w = 0; w < listPurchasing.length; w++) {
            if(listPurchasing[w].used_for=="0"){
              let ind2 = _.findIndex(ppdtl, {id_pp_dtl: listPurchasing[w].po_wo_id});
              ppdtl[ind2].saldo = ppdtl[ind2].saldo + 
                (((listPurchasing[w].value*(listPurchasing[w].quantity ? listPurchasing[w].quantity : 1))/totalitem)*listPurchasing[i].value);
            }
          }
        }
      }
      //cek ppdtl apakah ada yang minus
      for (let q = 0; q < ppdtl.length; q++) {
        if(ppdtl[q].saldo<0)
          valid = false;
      }

      let ttl = 0;
      let isexistitem = _.filter(listPurchasing, (item) => item.used_for == "0")
      for (let c = 0; c < listPurchasing.length; c++) {
        if (listPurchasing[c].used_for=='0' || listPurchasing[c].used_for=='3' || listPurchasing[c].used_for=='4'){
          ttl += Number(listPurchasing[c].value)*(listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
        }else if(listPurchasing[c].used_for=='2' && listPurchasing[c].type_tax!=undefined && listPurchasing[c].type_tax!=null
          && !listPurchasing[c].type_tax.includes('pph')){
            ttl += Number(listPurchasing[c].value)*(listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
        } else {
          if (isexistitem.length == 0) {
            ttl += Number(listPurchasing[c].value) * (listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
          } else {
            ttl -= Number(listPurchasing[c].value) * (listPurchasing[c].quantity ? listPurchasing[c].quantity : 1);
          }
        }
      }

      if(ttl<0){
        grandtotalminus = true;
        valid = false;
      }

      return {valid,ppdtl,grandtotalminus};
    },
    lblTax(val){
      let result = _.filter(this.getType_tax,(item)=>item.value==val);
      return (result.length>0 ? result[0].text : "");
    },
    handleChangepowoPdtl(){
      // console.log(val,this.po_wo_dtl)
      // if(this.po_wo_dtl.length>0){
      //   let result = _.filter(this.po_wo_dtl,(item)=>item.id_pp_dtl==val);
      //   this.dtl_desc.unit_price = result[0].unit_price;
      //   this.dtl_desc.qty = result[0].qty;
      //   this.dtl_desc.currency = result[0].currency;

      // }else{
      //   this.dtl_desc.unit_price = "";
      //   this.dtl_desc.qty = "";
      //   this.dtl_desc.currency = "";
      // }
    },
    handleToEdit(item){
      this.editData = item;
      this.net_value = item.value*(item.quantity ? item.quantity : 1);
      this.handleChangepowoPdtl(item.po_wo_id);
      this.editModal = !this.editModal;

      let ppdtl = []; 
      if(item.po_wo_id){     
        for (let t = 0; t < this.po_wo_dtl.length; t++) {
          ppdtl.push({...this.po_wo_dtl[t]});
        }
        let index = _.findIndex(ppdtl, (e) => {return e.id_pp_dtl == item.po_wo_id;}, 0); 
        this.editData.powovalue_before = ppdtl[index].saldo;
        ppdtl[index].saldo = Number(ppdtl[index].saldo) + (Number(item.value)*(item.quantity ? item.quantity : 1));
        Event.$emit("updatepowodtl", { value: ppdtl});
      }

      let usdval = {target:{value:item.used_for}};
      this.handleUseFor(usdval);

      if(item.attachment){
        this.trigered.attachment = true;
        this.fileList.push(item.attachment);
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            attachment: item.attachment,
          });
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemoveList() {
      this.fileList = [];
    },
    handleToPreview(val){
      let blob = new Blob([val.attachment], { type: val.attachment.type }),
        url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    lblusedfor(val){
      if(val=="0"){
        return "Item";
      }else if(val=="2"){
        return "Tax";
      }else if(val=="3"){
        return "Shipping";
      }else if(val=="4"){
        return "Etc";
      }else if(val=="1"){
        return "Discount";
      }else{
        return "";
      }
    },
    taxTypeChange(){

    },
    convertingValue(val){
      if(val){
        this.net_value = this.informasi.mata_uang!='IDR' ? (val / Number(this.informasi.kurs)) : val
        this.net_value = (this.$refs.rawqty ? this.$refs.rawqty.value : 1)*this.net_value
      }else{
        this.net_value = null
      }
    },
    convertingValueQty(val){
      if(val){
        this.net_value = this.informasi.mata_uang!='IDR' ? (this.$refs.rawval.value / Number(this.informasi.kurs))*val : this.$refs.rawval.value*val
      }else{
        this.net_value = null
      }
    },
    convertingValue2(val){
      if(val){
        this.net_value = this.informasi.mata_uang!='IDR' ? (val / Number(this.informasi.kurs)) : val
        this.net_value = (this.$refs.rawqty2 ? this.$refs.rawqty2.value : 1)*this.net_value
      }else{
        this.net_value = null
      }
    },
    convertingValueQty2(val){
      if(val){
        let a = this.$refs.rawval2 ? this.$refs.rawval2.value : 1
        this.net_value = this.informasi.mata_uang!='IDR' ? (a / Number(this.informasi.kurs))*val : a*val
      }else{
        this.net_value = null
      }
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
.m-price-total {
  &_dtl {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;

    li {
      display: flex;
      flex-direction: column;
      padding-bottom: @padding / 2;
      border-bottom: 1px solid darken(white, 10);

      h4 {
        text-transform: capitalize;
      }
    }

    &__value {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>

<style lang="less">
.footer-list {
  display: flex;
  justify-content: flex-end;
  .ant-row {
    width: 100%;
  }
}
.footer-light {
  font-size: medium;
}
.divnone {
  display: none;
}
.divblock {
  display: block;
}
</style>
